/**
 * 动态配置地址
 * */
import axios from 'axios'


export const App = function (url) {
  this.request = axios.create({
    baseURL: url,
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
  })

  // this.request.interceptors.request.use(
  //   config => {
  //     // 在头部带上authorization
  //     config.headers['authorization'] = localToken.read() || ''
  //     return config
  //   },
  //   error => {
  //     console.log(error) // for debug
  //     return Promise.reject(error)
  //   }
  // )

  // this.request.interceptors.response.use(
  //   response => {
  //     // 如果响应头携带了authorization（通常是登录成功或刷新登录时携带），就存进localStorage，后续请求都带这个头
  //     const auth = response.headers['authorization']
  //     if (auth) {
  //       localToken.write(auth)
  //     }
  //     // 取出真正的数据（剥去axios额外包的一层）
  //     const res = response.data


  //     // 返回真正的数据部分
  //     return res
  //   },
  //   error => {
  //     // 出错的处理
  //     console.log('err' + error)
  //     // Message({
  //     //   message: error.message,
  //     //   type: 'error',
  //     //   duration: 5 * 1000
  //     // })
  //     return Promise.reject(error)
  //   }
  // )
}



// WEBPACK FOOTER //
// ./src/api/.request-address.js